import React, { useEffect, useState } from 'react';
import { Input, Radio, RadioChangeEvent } from 'antd';
import { paymentType, initPaymentType } from '../../../model/master';

const { TextArea } = Input;

interface Props {
    paymentType: paymentType;
    disabled?: boolean;
    onChange: (data: any) => void;
}

const PaymentTypeDetail: React.FC<Props> = (props) => {
    const [data, setData] = useState<paymentType>(initPaymentType);

    const onDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key: string = String(e.target.name);
        const value: any = e.target.value;
        const updated: any = { ...data, [key]: value };
        setData(updated);
        props.onChange(updated);
    };

    const onStatusChange = (e: RadioChangeEvent) => {
        const updated: any = { ...data, status: e.target.value };
        setData(updated);
        props.onChange(updated);
    };

    useEffect(() => {
        setData(props.paymentType || initPaymentType);
    }, [props.paymentType]);

    return (
        <div className='detailFormContainer' data-testid="payment-type-detail-form">
            <div className='formRow' style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '16px' }}>
                <div className='formGroup'>
                    <label className='formLabel required'>รหัสประเภท (Code)</label>
                    <Input 
                        name="code" 
                        placeholder="เช่น C, QR, CC, T" 
                        value={data.code} 
                        onChange={onDataChange} 
                        disabled={props.disabled}
                        style={{ textTransform: 'uppercase' }}
                    />
                </div>
                <div className='formGroup'>
                    <label className='formLabel required'>ชื่อประเภทการชำระเงิน</label>
                    <Input 
                        name="name" 
                        placeholder="เช่น เงินสด, สแกน QR, บัตรเครดิต, คูปอง" 
                        value={data.name} 
                        onChange={onDataChange} 
                        disabled={props.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>คำอธิบาย / หมายเหตุ</label>
                    <TextArea 
                        name="remark" 
                        rows={3} 
                        placeholder="ระบุรายละเอียดเพิ่มเติมเกี่ยวกับช่องทางการรับเงินนี้..." 
                        value={data.remark || ''} 
                        onChange={onDataChange} 
                        disabled={props.disabled} 
                    />
                </div>
            </div>

            <div className='formRow'>
                <div className='formGroup'>
                    <label className='formLabel'>สถานะการใช้งาน</label>
                    <Radio.Group 
                        onChange={onStatusChange} 
                        value={data.status !== undefined ? data.status : 1}
                        disabled={props.disabled}
                    >
                        <Radio value={1}>🟢 ใช้งานปกติ (Active)</Radio>
                        <Radio value={0}>⚪ ปิดการใช้งาน (Inactive)</Radio>
                    </Radio.Group>
                </div>
            </div>
        </div>
    );
};

export default PaymentTypeDetail;
